"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreFunnelChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var BaseChart_1 = require("../_base/BaseChart");
var CoreFunnelChart = /** @class */ (function (_super) {
    tslib_1.__extends(CoreFunnelChart, _super);
    function CoreFunnelChart(props) {
        var _this = _super.call(this, props) || this;
        sdk_ui_1.visualizationIsBetaWarning();
        return _this;
    }
    CoreFunnelChart.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "funnel" }, this.props));
    };
    return CoreFunnelChart;
}(react_1.default.PureComponent));
exports.CoreFunnelChart = CoreFunnelChart;
//# sourceMappingURL=CoreFunnelChart.js.map